import { PodcastLanguage } from './language.js';
export const PodcastLanguageMap = {
    'de': [PodcastLanguage.de, PodcastLanguage.de_DE],
    'de-de': [PodcastLanguage.de, PodcastLanguage.de_DE],
    'de_de': [PodcastLanguage.de, PodcastLanguage.de_DE],
};
